module.exports = __webpack_public_path__ + "img/4.566646bc.jpeg";